import { type IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import type { FieldProps } from 'formik';
import { type FC } from 'react';

export const NewLine: FC = () => {
  return <span className="formNewLine" />;
};

export default NewLine;
